import React from 'react';
import { format } from 'date-fns';
import { Box, Flex, Text } from 'rebass';
import { Column } from '../../hooks/useTablePages';
import ActivityActionButtons from '../../components/ActivityFeed/ActivityActionButtons';
import type { NotificationActions } from '../../components/ActivityFeed/useNotificationActions';

const getColumns = (
  notificationActions: NotificationActions,
  onActionComplete?: () => void | Promise<void>
): Column[] => [
  {
    header: 'Time',
    id: 'eventTime',
    accessor: (row) => (
      <Text
        color={row.dismissed ? 'onNavbar' : 'text'}
        sx={{ opacity: row.dismissed ? 0.55 : 1 }}
      >
        {format(new Date(row.time), 'M/d/yyyy h:mm a')}
      </Text>
    ),
    stringAccessor: (row) => format(new Date(row.time), 'M/d/yyyy h:mm a'),
    width: 150,
  },
  {
    header: 'Activity',
    id: 'activity',
    accessor: (row) => (
      <Box sx={{ minWidth: 0 }}>
        <Flex alignItems="center" sx={{ gap: 2, minWidth: 0 }}>
          {(row.followUp || !row.read) && (
            <Box
              sx={{
                flexShrink: 0,
                width: 8,
                height: 8,
                borderRadius: 'circle',
                bg: row.followUp ? 'statusOrange' : 'primary',
              }}
            />
          )}
          <Text
            fontWeight={!row.read ? 'bold' : 'body'}
            color="text"
            title={row.title}
            sx={{
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontStyle: row.followUp ? 'italic' : 'normal',
            }}
          >
            {row.title}
          </Text>
        </Flex>
        <Text
          color="onNavbar"
          title={row.body}
          sx={{
            mt: '3px',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {row.body}
        </Text>
      </Box>
    ),
    stringAccessor: (row) => `${row.title} ${row.body}`,
    width: 250,
    fillRemainingWidth: true,
    sortable: false,
  },
  {
    header: 'Actions',
    id: 'actions',
    accessor: (row) => (
      <Flex alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
        <ActivityActionButtons
          notification={row}
          onMarkRead={notificationActions.markRead}
          onMarkUnread={notificationActions.markUnread}
          onMarkAsFollowUp={notificationActions.markAsFollowUp}
          onUnMarkAsFollowUp={notificationActions.unMarkAsFollowUp}
          onDismiss={notificationActions.dismiss}
          onUndismiss={notificationActions.undismiss}
          onActionComplete={onActionComplete}
        />
      </Flex>
    ),
    stringAccessor: () => '',
    width: 92,
    sortable: false,
  },
];

export default getColumns;
